<template>
  <div class="range-slider">
    <div class="fill"></div>
    <div class="empty" v-bind:style="{width: gradientFill + '%'}"></div>
    <input type="range" v-bind:min="min" v-bind:value="value" v-bind:max="max" v-bind:step="step" v-on:input="updateValue" class="slider-input" >

    <div class="marker">
      <div class="min marker-label">{{ isDollar ? '$' : null }}{{min}}</div>
      <div class="middle marker-label">{{ isDollar ? '$' : null }}{{max/2}}</div>
      <div class="max marker-label">{{ isDollar ? '$' : null }}{{max}}</div>
    </div>

    <div class="range-value" ref="rangeTooltip" v-bind:style="{left: 100 - gradientFill + '%', marginLeft: toolTip + 'px' }">{{ isDollar ? '$' : null }}{{value}}</div>
  </div>

</template>

<script>
export default {
  name: 'range-slider',
  props: {
    model: {
      default: null,
      type: String
    },
    min: {
      default: "1",
      type: String
    },
    max: {
      default: "1000",
      type: String
    },
    step: {
      default: "1",
      type: String
    },
    value: {
      default: 500,
      type: Number
    },
    isDollar: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      currentValue: null
    }
  },
  computed: {
    gradientFill: function() {

      if (this.currentValue) {
        return ((100 - ((this.currentValue / this.max) * 100)).toFixed(2))
      }
      else {
        return ((100 - ((this.value / this.max) * 100)).toFixed(2))
      }
    },
    toolTip: function() {
      if (this.currentValue) {
        let offset
        if (this.currentValue > 1000) {
          offset = -14
        }
        else {
          offset = -7
        }
        return (offset - (1 * (this.currentValue / this.max) * 37 ))
      }
      else {
        return (-7 - (1 * (this.value / this.max) * 37 ))
      }
    }
  },
  methods: {
    updateValue(e) {
      this.currentValue = e.target.value
      this.$emit('update-value', this.model, e.target.value)
    }
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.range-slider {
  position: relative;
}
@media (max-width: 1000px) {
  .range-slider {
    margin: 50px 0;
  }
}
input[type="range"] {
  -webkit-appearance: none !important;
  width: 100%;
  height: 15px;
  background-color: transparent;
  border: none;
  border-radius: 4px;
  margin: 0;
  padding: 0;
  transition: all 0.3s ease;
  position: relative;
  outline: none;
}
input[type=range]::-moz-range-track {
  width: 100%;
  height: 15px;
  background-image: linear-gradient(90deg, #03FFD7 0%, #199ED9 99%);
  border-radius: 4px;
}

.empty {
  height: 15px;
  display: block;
  background-color: #D0DCE0;
  border-radius: 4px;
  position: absolute;
  right: 0;
  padding: 0;
  z-index: 0;
}
.fill {
  position: absolute;
  border-radius: 4px;
  pointer-events: none;
  background-image: linear-gradient(90deg, #03FFD7 0%, #199ED9 99%);
  position: absolute;
  width: 100%;
  height: 15px;
}
/* Chrome Styling */
input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: 36px;
  width: 36px;
  background: url(../assets/images/slider-dial.svg) no-repeat center;
  border: none;
  padding:0;
  margin: 0;
  position: relative;
  z-index: 999;
  cursor: pointer;
  top: -9px;
}
input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 15px;
  cursor: pointer;
  box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
  border-radius: 0px;
  z-index: 1;
  border: 0px solid rgba(0, 0, 0, 0);
}

/* Firefox Styling */
input[type=range]::-moz-range-thumb {
  -moz-appearance: none;
  height: 36px;
  width: 36px;
  background-color: transparent;
  border: none;
  background: url(../assets/images/slider-dial.svg) no-repeat center;
  padding:0;
  margin: 0;
  position: relative;
  z-index: 999;
  cursor: pointer;
  top: 0px;
}
input[type=range]::-moz-range-track {
  width: 100%;
  height: 15px;
  cursor: pointer;
  background: none transparent;
  border-radius: 0px;
  border: 0px solid rgba(0, 0, 0, 0);
  position: relative;
  z-index: -1;
}

/* IE Styling */
/* IE style settings */
input[type=range]::-ms-track {
  width: 100%;
  height: 15px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
input[type=range]::-ms-fill-lower {
  background: #03FFD7;
  border: 0px solid rgba(0, 0, 0, 0);
  border-radius: 0px;
  box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
}
input[type=range]::-ms-fill-upper {
  background: #D0DCE0;
  border: 0px solid rgba(0, 0, 0, 0);
  border-radius: 0px;
  box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
}

input[type=range]::-ms-thumb {
  box-shadow: g #000000, 0px 0px 1px #0d0d0d;
  border: 0px solid rgba(255, 255, 255, 0);
  height: 10px;
  width: 10px;
  border-radius: 5px;
  background: #ffffff;
  cursor: pointer;
  height: 6px;
  z-index: 2000;
  position: relative;

}

.marker {
  position: absolute;
  width: 100%;
}
.marker-label {
  float: left;
  width: 33.3333%;
  display: block;
  color: #498DA6;
  font-size: 14px;
  margin-top: 10px;
}

.max {
  text-align: right;
}

.middle {
  text-align: center;
}

.marker:after {
  clear: both;
  display: block;
  content: ' ';
}

.range-value {
  min-width: 50px;
  text-align: center;
  display: inline-block;
  padding:10px;
  background-color: white;
  color: black;
  top: 30px;
  border-radius: 4px;
  position: absolute;
  margin-left: -5px;
}
.range-value:after {
  width: 0;
  height: 0;
  position: absolute;
  content: '';
  top: -5px;
  left: calc(50% - 5px);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid white;
}
</style>



// WEBPACK FOOTER //
// RangeSlider.vue?51497a98